import React from 'react';

import type { NormalizedResource } from '@components/DynamicResourceForms/DynamicResourceForms';

import type { CuratedFhirResource } from '@contexts/auto-curation';
import { AutoCurationContext, ResourceActions } from '@contexts/auto-curation';

/**
 * Hook to manage auto-curation resource state
 */
export function useAutoCuration() {
  const context = React.useContext(AutoCurationContext);

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (context === undefined || context === null) {
    throw new Error(
      'useAutoCuration must be used within an AutoCurationProvider'
    );
  }

  const { state, dispatch } = context;

  const addManualResource = (resource: NormalizedResource) => {
    dispatch({
      type: ResourceActions.AddManualResource,
      resource,
    });
  };

  const removeManualResource = (id: string) => {
    dispatch({
      type: ResourceActions.RemoveManualResource,
      id,
    });
  };

  const setRecord = (record: CuratedFhirResource | null) => {
    dispatch({
      type: ResourceActions.SetRecord,
      record,
    });
  };

  return {
    state,
    dispatch,
    addManualResource,
    removeManualResource,
    setRecord,
  };
}
